import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  InformationCardRowComponent,
  type InformationCard,
} from '@content/ui/cards/information-cards';
import {
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import {
  DEFAULT_LINK_FIELD,
  DEFAULT_TEXT_FIELD,
  getField,
  normalizeLinkField,
} from '@core/jss-utils';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

const TWO_CARD_ROW_SECTION = 2;
const THREE_CARD_ROW_SECTION = 3;
const FOUR_CARD_ROW_SECTION = 4;

@Component({
  selector: 'wl-information-card-row-container',
  templateUrl: './information-card-row.container.component.html',
  standalone: true,
  imports: [InformationCardRowComponent, ContentSectionComponent],
})
export class InformationCardRowContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly numberOfCards = computed<number>(() => {
    switch (this.rendering()?.componentName) {
      case 'InformationCard2Section':
        return TWO_CARD_ROW_SECTION;
      case 'InformationCard3Section':
        return THREE_CARD_ROW_SECTION;
      case 'InformationCard4Section':
        return FOUR_CARD_ROW_SECTION;
      default:
        return TWO_CARD_ROW_SECTION;
    }
  });

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'Title'));
  readonly content = computed(() =>
    getField<RichTextField>(this.fields(), 'Content')
  );
  readonly cards = computed<InformationCard[]>(() => {
    const cards = [];
    for (let i = 1; i <= this.numberOfCards(); i++) {
      cards.push(this.getCard(i));
    }
    return cards;
  });

  getCard(index: number): InformationCard {
    return {
      id: `card-${index}`,
      title: getField<TextField>(
        this.fields(),
        `Card${index}Title`,
        DEFAULT_TEXT_FIELD
      ),
      content: getField<TextField>(
        this.fields(),
        `Card${index}Content`,
        DEFAULT_TEXT_FIELD
      ),
      image: getField<ImageField>(this.fields(), `Card${index}Image`),
      button: normalizeLinkField(
        getField<LinkField>(
          this.fields(),
          `Card${index}Button`,
          DEFAULT_LINK_FIELD
        )
      ) as LinkField,
    };
  }
}
